import config from '../../../../config';
import { AddLicenseTerm } from '../../../domainModels/licenseTerms/AddLicenseTerm';
import { LicenseTerm, LicenseTermApi } from '../../../domainModels/licenseTerms/LicenseTerm';
import { UpdateLicenseTerm } from '../../../domainModels/licenseTerms/UpdateLicenseTerm';
import { axiosInstance as axios } from '../../axios/axiosInstance';
import { mapApiLicenseTermsModel } from './mappings/mapApiLicenseTermsModel';

export const licenseTermsEndpoint = `${config.tachoAPI.url}/licenseTerms`;

export const getLicenseTerms = (): Promise<Array<LicenseTerm>> => {
    return axios
        .get<Array<LicenseTermApi>>(licenseTermsEndpoint)
        .then(response => {
            return response.data.map(item => mapApiLicenseTermsModel(item));
        })
        .catch(err => {
            throw Error(getLicenseTerms.name + err);
        });
};

const onUploadProgress = (onProgress: (percent: number, loaded: number, total: number) => void) => (progressEvent: any) => {
    const { loaded, total } = progressEvent;
    let percent = Math.floor((loaded * 100) / total);
    if (percent < 100) {
        console.log(`${loaded} bytes of ${total} bytes. ${percent}%`);
    }

    if (onProgress != null) {
        onProgress(percent, loaded, total);
    }
};

export const createLicenseTerm = (
    model: AddLicenseTerm,
    onProgress: (percent: number, loaded: number, total: number) => void,
): Promise<boolean> => {
    const requestOptions = {
        headers: { 'Content-Type': 'multipart/form-data' },
        crossdomain: true,
        timeout: 0,
        onUploadProgress: onUploadProgress(onProgress),
    };
    var bodyFormData = new FormData();
    model.file && bodyFormData.append('file', model.file);
    bodyFormData.append('endDate', model.endDate.toString());
    bodyFormData.append('startDate', model.startDate.toString());
    bodyFormData.append('notes', model.notes.toString());
    bodyFormData.append('licenseType', model.licenseType.toString());
    return axios
        .post<AddLicenseTerm>(licenseTermsEndpoint, bodyFormData, requestOptions)
        .then(response => {
            return true;
        })
        .catch(error => {
            if (error.response!.status === 409) {
                throw Error('licenseTermConflicted');
            }

            throw Error(createLicenseTerm.name + error);
        });
};

export const updateLicenseTerm = (
    model: UpdateLicenseTerm,
    onProgress: (percent: number, loaded: number, total: number) => void,
): Promise<UpdateLicenseTerm> => {
    const requestOptions = {
        headers: { 'Content-Type': 'multipart/form-data' },
        crossdomain: true,
        timeout: 0,
        onUploadProgress: onUploadProgress(onProgress),
    };
    var bodyFormData = new FormData();
    model.file && bodyFormData.append('file', model.file);
    bodyFormData.append('endDate', model.endDate.toString());
    bodyFormData.append('startDate', model.startDate.toString());
    bodyFormData.append('notes', model.notes.toString());
    bodyFormData.append('licenseType', model.licenseType.toString());

    return axios
        .patch<UpdateLicenseTerm>(`${licenseTermsEndpoint}/${model.licenseTermId}`, bodyFormData, requestOptions)
        .then(response => {
            return model;
        })
        .catch(error => {
            throw Error(updateLicenseTerm.name + error);
        });
};

export const removeLicenseTerm = (licenseTermId: string): Promise<string> => {
    return axios
        .delete(`${licenseTermsEndpoint}/${licenseTermId}`)
        .then(response => {
            return licenseTermId;
        })
        .catch(error => {
            throw Error(removeLicenseTerm.name + error);
        });
};
